import { createFileRoute } from '@tanstack/react-router';
import ReminderManagement from '../../components/manager/ReminderManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/reminders')({
  component: ReminderManagementRoute,
});

function ReminderManagementRoute() {
  return (
    <ManagerPortal>
      <ReminderManagement />
    </ManagerPortal>
  );
}
